function importAll(r) {
  let images = {};
  r.keys().forEach((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}
const images = importAll(
  require.context("../../../../public/slideshow", false, /\.(png|jpe?g|svg|avif)$/)
);
const arr = Object.values(images)
// console.log(Object.values(images));

export const SliderData = arr.map((image)=>{
  return {
    image: image,
  }
});
